import { Date } from './primitives/Date';

function ArticlePublishDate({ date }) {
  return <Date data-test="article-publish-date">{date}</Date>;
}

ArticlePublishDate.propTypes = { date: PropTypes.string.isRequired };

export default ArticlePublishDate;
